/* global axios */

import ApiClient from './ApiClient';

class KaptionDeliveryWebhooksAPI extends ApiClient {
  constructor() {
    super('kaption_delivery_webhooks', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  revoke(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  rotate(id) {
    return axios.post(`${this.url}/${id}/rotate`);
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }
}

export default new KaptionDeliveryWebhooksAPI();
